import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import ContactForm from './ContactForm';
import Message from './Message';

const FrontPageContact = props => {
  const { image } = props;
  const SuccessMessage = () => (
    <Message
      isSuccess
      message="Your message has been sent.<br/> Thank you for reaching out. I will respond as soon as I can."
    />
  );
  const FailMessage = () => (
    <Message
      isSuccess={false}
      message="Oops -- something went wrong. Please correct the errors and try again"
    />
  );

  return (
    <section className="front-page--section">
      <h1 className="front-page--title front-page--title-divider">Let’s Talk</h1>
      <div className="columns">
        <div className="column">
          <div>
            <Img
              alt="Two brains having an idea. Image courtesy of and copyright Free Range Stock, www.freerangestock.com"
              className="front-page--image"
              resolutions={image.resolutions}
            />
          </div>
          <div>
            <p>
              I know it&apos;s hard to find the right people for your project or business. I am also
              selective about who I work with. I have great ideas, strong technical capabilities and
              a focus on exceeding expectations for those who are passionate about what they want to
              accomplish.
            </p>
            <p>If you think I may be able to help you achieve your goals, get in touch!</p>
            <p>
              Please use the form to send me a little information on your project so I can determine
              how best to help you.
            </p>
          </div>
        </div>

        <div className="column">
          <div className="has-text-left">
            <ContactForm successMessage={SuccessMessage} failMessage={FailMessage} />
          </div>
        </div>
      </div>
    </section>
  );
};

FrontPageContact.propTypes = {
  image: PropTypes.shape({
    sizes: PropTypes.object,
  }).isRequired,
};

export default FrontPageContact;



// WEBPACK FOOTER //
// ./src/components/FrontPageContact.js